<template>
  <a-card :bordered="false" class="h-full" :bodyStyle="{ padding: '0px' }">
    <a-form inline>
      <a-form-item>
        <a-button type="primary" @click="getDataList" :loading="dataListLoading">刷新数据</a-button>
      </a-form-item>
    </a-form>
    <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="signFlowId"
      :loading="dataListLoading" :scroll="{ x: 1200, y: 600 }">
      <template slot="signFlowTitle" slot-scope="signFlowTitle, row">
        <a-tooltip :title="row.signFlowInitiator.orgInitiator.orgName">
          <div style="color: #000;">{{ signFlowTitle }}</div>
          <div style="color: #999;">发起人: {{ row.signFlowInitiator.orgInitiator.orgName }}</div>
        </a-tooltip>
      </template>
      <template slot="signFlowId" slot-scope="signFlowId, row">
        <a-popover trigger="hover" placement="topLeft">
          <template slot="content">
            <span>签署流程ID: {{ signFlowId }}</span>
          </template>
          {{ signFlowId }}
        </a-popover>
      </template>
      <template slot="signFlowStartTime" slot-scope="signFlowStartTime, row">
        <div>{{ moment(signFlowStartTime).format('YYYY-MM-DD HH:mm:ss') }}</div>
        <div style="color: #999;">{{ row.signFlowEndTime ? moment(row.signFlowEndTime).format('YYYY-MM-DD HH:mm:ss') :
          '-' }}</div>
      </template>
      <template slot="signers" slot-scope="signers, row">
        <a-popover title="签署合同" style="font-weight: 400;">
          <template slot="content">
            <a-timeline>
              <a-timeline-item v-for="(v, index) in signers" :key="index" :color="getSignStatusColor(v.signStatus)">
                <a-space direction="vertical">
                  <div v-if="v.orgSigner">
                    <div>{{ v.orgSigner.transactor.psnAccount.accountMobile }}</div>
                    <div style="color: #999">
                      {{ v.orgSigner.orgName }}
                    </div>
                  </div>
                  <div v-if="v.psnSigner">
                    {{ v.psnSigner.psnAccount.accountMobile }}
                  </div>
                  <div>{{ getSignStatus(v.signStatus) }}</div>
                  <a v-if="v.signStatus == 1 && v.orgSigner"
                    @click="getSignLink(row.signFlowId, v.orgSigner.transactor.psnId, 2)">获取签署链接</a>
                  <a v-if="v.signStatus == 1 && v.psnSigner"
                    @click="getSignLink(row.signFlowId, v.psnSigner.psnId, 2)">获取签署链接</a>
                  <a v-if="v.signStatus == 2 && v.orgSigner"
                    @click="getSignLink(row.signFlowId, v.orgSigner.transactor.psnId, 1)">查看签署链接</a>
                  <a v-if="v.signStatus == 2 && v.psnSigner"
                    @click="getSignLink(row.signFlowId, v.psnSigner.psnId, 1)">查看签署链接</a>
                </a-space>
              </a-timeline-item>
            </a-timeline>
          </template>
          <div v-for="(v, index) in signers" :key="index">
            <div v-if="v.orgSigner">
              <a-badge :color="getSignStatusColor(v.signStatus)"
                :text="`${v.orgSigner.transactor.psnAccount.accountMobile} (${v.orgSigner.orgName})`" />
            </div>
            <div v-if="v.psnSigner">
              <a-badge :color="getSignStatusColor(v.signStatus)" :text="`${v.psnSigner.psnAccount.accountMobile}`" />
            </div>
          </div>
        </a-popover>
      </template>
      <template slot="action" slot-scope="action, row">
        <a-space direction="vertical">
          <a v-if="row.signFlowStatus == 1" @click="endSignFlow(row.signFlowId)">完结签署</a>
        </a-space>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    customer_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      moment,
      getDataListURL: "/admin/customer/queryCustomerContract",
      dataList: [],
      page: 1,
      limit: 10,
      total: 0,
      dataListLoading: false,
      columns: [
        {
          title: "合同名称",
          dataIndex: "signFlowTitle",
          width: 200,
          scopedSlots: { customRender: "signFlowTitle" },
          ellipsis: true
        },
        {
          title: "签署流程ID",
          dataIndex: "signFlowId",
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: "signFlowId" },
        },
        {
          title: "签署发起/结束时间",
          dataIndex: "signFlowStartTime",
          width: 200,
          scopedSlots: { customRender: "signFlowStartTime" },
        },
        {
          title: "合同状态",
          dataIndex: "signFlowStatus",
          width: 150,
          customRender: (text) => this.getSignStatus(text)
        },
        {
          title: "签署操作方",
          dataIndex: "signers",
          width: 250,
          scopedSlots: { customRender: "signers" },
          ellipsis: true
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          width: 100,
        },
      ],
    };
  },
  watch: {
    customer_id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getDataList();
        }
      }
    }
  },
  methods: {
    //根据状态返回中文
    // 当前签署状态
    // 0 - 等待签署
    // 1 - 签署中
    // 2 - 已签署
    // 3 - 等待审批
    // 4 - 已拒签
    getSignStatus(status) {
      if (status == 0) {
        return '等待签署';
      } else if (status == 1) {
        return '签署中';
      } else if (status == 2) {
        return '已签署';
      } else if (status == 3) {
        return '等待审批';
      } else if (status == 4) {
        return '已拒签';
      } else {
        return '未知状态';
      }
    },
    //签署颜色
    getSignStatusColor(status) {
      if (status == 0) {
        return 'grey';
      } else if (status == 1) {
        return '#108ee9';
      } else if (status == 2) {
        return '#87d068';
      } else if (status == 3) {
        return 'orange';
      } else if (status == 4) {
        return 'red';
      } else {
        return 'geekblue';
      }
    },
    //完结签署
    endSignFlow(signFlowId) {
      this.$confirm({
        title: '完结签署流程，完成后的签署流程不允许再添加、删除签章区域，也不允许撤销签署流程',
        content: "是否确认完结签署流程？",
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          if (!signFlowId) return;
          this.$http.post("/admin/customer/endSignFlow", {
            signFlowId: signFlowId,
          }).then(({ data }) => {
            this.$message.success("完结签署成功");
            this.getDataList();
          });
        }
      });
    },
    getDataList() {
      if (!this.customer_id) return;
      this.dataListLoading = true;
      this.$http.get(this.getDataListURL, {
        params: {
          customer_id: this.customer_id,
        }
      }).then(({ data }) => {
        this.dataList = data.signFlowInfos || [];
        this.dataListLoading = false;
      });
    },
    // 获取签署链接
    getSignLink(signFlowId, psnId, urlType) {
      console.log(signFlowId, psnId)
      if (!signFlowId || !psnId) return;
      this.$http.post("/admin/customer/querySignUrl", {
        signFlowId: signFlowId,
        psnId: psnId,
        urlType: urlType,
      }).then(({ data }) => {
        console.log(data)
        this.$message.success("获取签署链接成功");
        window.open(data);
      });
    },
  }
};
</script>